
import React from 'react';
import DataTable from "react-data-table-component";
import api from './api';
import './Doctors.css';
//import Roles from './Roles';
//import ListRoles from './ListRoles';
//import SortIcon from "@material-ui/icons/ArrowDownward";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { FaEdit, FaPlus, FaTrash } from "react-icons/fa";

//import MDButton from './MDButton';

//import "./styles.css";

import {
    useState,
    useEffect
} from 'react';

const Roles = () => {
  const [roles, setRoles] = useState([]);
  const [staffTypes, setStaffTypes] = useState([]);
  const [newRole, setNewRole] =
      useState({ type: "" });
  const [selectedRole, setSelectedRole] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
      
    useEffect(
      () => {
          api.get(`${process.env.REACT_APP_URL}/roles`)
              .then(response => { 
                //console.log("from mongo fetch",response.data);
                setRoles(response.data)
              })
              .catch(error =>
                  console.error('Error fetching roles:', error));
      }, []);

      
  const columns = [
    {
      name: "Type",
      selector: (row) => row.rtype,
      sortable: true,
    },
    {
      name: "Actions",
      sortable: false,
           
      cell: (row) => [
        <div className='task-icon'
        
        >
        <FaEdit
        
        onClick={handleEditRole.bind(this,row?._id)}
      ></FaEdit></div>,
      
      <div className='task-icon'>
      <FaTrash 
        
        onClick={handleDeleteRole.bind(this,row?._id)}
        
      ></FaTrash> </div>
      ]
    },
    ];
  
      //const data = roles;
      const tableData = {
        columns:columns,
        data:roles
      };
    // A super simple expandable component.
      const ExpandedComponent = ({ roles }) => <pre>{JSON.stringify(roles, null, 2)}</pre>;
      const getStaffTypes = 
        () => {
            api.get(`${process.env.REACT_APP_URL}/staffTypes`)
                .then(response => { 
                  //console.log("from mongo fetch",response.data);
                  setStaffTypes(response.data)
                })
                .catch(error =>
                    console.error('Error fetching StaffTypes:', error));
        };

  
      const getRoles = 
        () => {
            api.get(`${process.env.REACT_APP_URL}/roles`)
                .then(response => { 
                  //console.log("from mongo fetch",response.data);
                  setRoles(response.data)
                })
                .catch(error =>
                    console.error('Error fetching roles:', error));
        };

        const handleAddRole =
        (e) => {
            e.preventDefault();

            api.post(
`${process.env.REACT_APP_URL}/roles/add`, newRole)
                .then(response => {
                    //console.log(response.data);
                     alert("Role added");
                    setRoles([...roles, response.data]);
                    setNewRole({});// name: '', age: '', gender: '' });
                })
                .catch(error =>
                    console.error('Error adding role:', error));
        };

    const handleUpdateRole =
        (id, e) => {
            e.preventDefault();

            api.post(
              `${process.env.REACT_APP_URL}/roles/update/${id}`, selectedRole)
                .then(response => {
                   alert("Role updated");
                    const updatePat = {
                        ...selectedRole,
                        _id: id
                    };

                    //console.log('update role', updatePat);

                    setRoles(
                        roles.map(
                            role =>
                            (role._id === id
                                ? updatePat : role)));

                    setSelectedRole(null);
                    setIsEditMode(false); // Switch back to Add mode
                    handleClose();
                })
                .catch(
                    error =>
                        console.error('Error updating role:', error));
        };

      const handleDeleteRole =
      (id) => {
        setSelectedRole(null);
  setIsModalOpen(false);
  setIsEditMode(false);
          //confirm("Are you sure you want to delete this entry ?");
          api.delete(
`${process.env.REACT_APP_URL}/roles/delete/${id}`)
              .then(response => {
                  //console.log(response.data);
                  setSelectedRole(null);
                  setRoles(
                      roles.filter(
                          role => role._id !== id));
              })
              .catch(
                  error =>
                      console.error('Error deleting role:', error));
      };

const handleEditRole =
(id) => {
//console.log(roles, columns, id);
  setSelectedRole(
   roles.find(
    (role) => {
    return (role._id == id )
  }));
  getStaffTypes();
  setIsModalOpen(true);
  setIsEditMode(true); // Switch to Edit mode
}

const handleAddNewRole = (e) => {
  e.preventDefault();

  setSelectedRole(null);
  setIsEditMode(false); // Switch to Add mode
  setIsModalOpen(true);
}

const handleClose = () => {
  setIsModalOpen(false);
  setSelectedRole(null);
  setIsEditMode(false);
  getRoles();
}

  return (
          <div>
    {isModalOpen ? (
      <div>
           <div className='tableheaderActions'>
      
           <button id="cnew" type="button" className='btn btn-outline-primary' aria-label='Add New'
           onClick={handleClose}
           > Close</button>
         </div>
         
        <div className='role-main  '>
            <div className='form-sections  '>
                <h4>
                    {
                        isEditMode ?
                            'Edit Role' :
                            'Add New Role'
                    }
                </h4>
                <form onSubmit=
                    {
                        isEditMode ?
                            (e) =>
                                handleUpdateRole(selectedRole._id, e) :
                            handleAddRole}>
                    <label>Role Type: </label>
                    <input type="text"
                        value={
                            isEditMode ?
                                selectedRole.type :
                                newRole.type
                        }
                        onChange={
                            (e) =>
                                isEditMode
                                    ? setSelectedRole(
                                        {
                                            ...selectedRole,
                                            type: e.target.value
                                        }) :
                                    setNewRole(
                                        {
                                            ...newRole,
                                            type: e.target.value
                                        }
                                    )} />
                    <br />
                    <button type="submit">
                        {
                            isEditMode ?
                                'Update Role' :
                                'Add Role'
                        }
                    </button>
                </form>
            </div>
        </div>
    

        </div>) 
      : 
      ( 
      <div> 
        <div className='tableheaderActions'>
      
          <button id="cnew" type="button" className='btn btn-outline-primary' aria-label='Add New'
            onClick={handleAddNewRole}
          > Add New</button>

        </div>
     
      <DataTableExtensions {...tableData} filter={true} filterLabel={false}>
        <DataTable columns={columns} data={roles} 
        selectableRows 
        pagination
        highlightOnHover	
        header="Table header"
        striped	
        pointerOnHover	
        dense	
        paginationPerPage={100} 
   persistTableHead	
        fixedHeader	
        fixedHeaderScrollHeight='300px' 
        //progressPending	
        defaultSortField="id"
        
        defaultSortAsc={true}
        direction
        expandableRows
        expandableRowsComponent={ExpandedComponent} />
      </DataTableExtensions>
      
</div>
)}
</div>
  );
}
export default Roles;